import { i18nMark } from 'lingui-react';

const messages = {
  loadMore: i18nMark('Load More'),
};

export default messages;



// WEBPACK FOOTER //
// ./components/_common/paginateFavorites/messages.js